import React from 'react';
import { Paper } from '@shared/ui/common';
import OnboardingOverlayCard from '../../shared/OnboardingOverlayCard';

interface SalesOnboardingPanelProps {
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/** Card content for sales onboarding overlays over the chart. */
const SalesOnboardingPanel: React.FC<SalesOnboardingPanelProps> = ({
  title,
  children,
  footer,
}) => (
  <Paper
    sx={{
      width: '100%',
      maxWidth: 560,
      maxHeight: '100%',
      overflow: 'auto',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    }}
  >
    <OnboardingOverlayCard title={title} footer={footer}>
      {children}
    </OnboardingOverlayCard>
  </Paper>
);

export default SalesOnboardingPanel;
